import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

declare var $: any;

@Injectable()
export class UserService {

  private httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})

};

    constructor(private http: HttpClient) {}

    public logar (url:string, parans:any, host: string):Observable<any>{
      var nUrl = host + url;
      if (url.indexOf("http") > -1){
          nUrl = url;
      }
      return this.http.post(nUrl, parans, this.httpOptions);
  }

    

}




// WEBPACK FOOTER //
// ./src/app/services/user.service.ts